export const checkSlidesForLearningObject = function (slides, learningObjectFlag) {
    slides.forEach(slide => {
        if (slide.type && slide.type === "LearningObject") {
            learningObjectFlag = true
        } else if (slide.children && slide.children.length > 0) {
            learningObjectFlag = !learningObjectFlag ? checkSlidesForLearningObject(slide.children, learningObjectFlag) : learningObjectFlag
        }
    })
    return learningObjectFlag
} 